// extracted by mini-css-extract-plugin
export default {"Homebrewdog":"nE7Znq8FT3WC5QU9RH3l"};